module.exports = __webpack_public_path__ + "img/image114.2e2d979c.jpg";